<template>
    <XyzTransition appear xyz="fade">
        <div class="bg-white rounded-lg shadow-md p-5 m-2 lg:mx-4">
            <div class="font-medium text-gray-700 text-xl mb-4">Remitente</div>
            <div class="flex flex-col h-24">
                <label for="sucursal" class="my-1 text-gray-700">
                    Sucursal<span class="text-red-400">*</span>
                </label>
                <Dropdown
                    v-model="sucursal_id"
                    placeholder="Seleccionar sucursal"
                    :options="sucursales"
                    optionValue="id"
                    optionLabel="nombre"
                    id="sucursal"
                    class="h-[42px] flex items-center"
                />
                <small
                    v-if="errors?.sucursal_id"
                    id="sucursal_id-help"
                    class="p-error"
                >
                    {{ errors?.sucursal_id[0] }}
                </small>
            </div>
            <div class="flex flex-col h-24">
                <label for="orden_id" class="my-1 text-gray-700">
                    Nro. de orden (opcional)
                </label>
                <input
                    type="text"
                    id="orden_id"
                    :class="['t-input', errors?.orden_id && 't-input-invalid']"
                    v-model="orden_id"
                />
                <small
                    v-if="errors?.orden_id"
                    id="orden_id-help"
                    class="p-error"
                >
                    {{ errors?.orden_id[0] }}
                </small>
            </div>
            <div class="flex items-center mb-4">
                <input
                    id="remitentePersonalizado"
                    aria-describedby="checkbox-1"
                    type="checkbox"
                    class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                    v-model="remitentePersonalizado"
                    :disabled="!sucursal_id"
                />
                <label
                    for="remitentePersonalizado"
                    :class="[
                        'ml-3 text-sm font-medium',
                        sucursal_id !== '' ? ' text-gray-700' : 'text-gray-400',
                    ]"
                >
                    Personalizar datos de origen
                </label>
            </div>

            <div
                v-if="sucursal_id && remitentePersonalizado"
                class="flex flex-col"
            >
                <div
                    class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2"
                >
                    <div class="w-full h-24">
                        <label for="origen_nombre" class="my-1 text-gray-700">
                            Nombre<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="origen_nombre"
                            :class="[
                                't-input',
                                errors?.origen_nombre && 't-input-invalid',
                            ]"
                            v-model="remitente.origen_nombre"
                        />
                        <small
                            v-if="errors?.origen_nombre"
                            id="nombre-help"
                            class="p-error"
                        >
                            {{ errors.origen_nombre[0] }}
                        </small>
                    </div>

                    <div class="w-full h-24">
                        <label
                            for="origen_documento"
                            class="my-1 text-gray-700"
                        >
                            Nro. documento
                        </label>
                        <input
                            type="text"
                            id="origen_documento"
                            :class="[
                                't-input',
                                errors?.origen_documento && 't-input-invalid',
                            ]"
                            v-model="remitente.origen_documento"
                        />
                        <small
                            v-if="errors?.origen_documento"
                            id="documento-help"
                            class="p-error"
                        >
                            {{ errors.origen_documento[0] }}
                        </small>
                    </div>
                </div>

                <div
                    class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2"
                >
                    <div class="w-full h-24">
                        <label for="origen_email" class="my-1 text-gray-700">
                            Email<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="email"
                            id="origen_email"
                            :class="[
                                't-input',
                                errors?.origen_email && 't-input-invalid',
                            ]"
                            v-model="remitente.origen_email"
                        />
                        <small
                            v-if="errors?.origen_email"
                            id="origen_email-help"
                            class="p-error"
                        >
                            {{ errors.origen_email[0] }}
                        </small>
                    </div>

                    <div class="w-full h-24">
                        <label for="origen_telefono" class="my-1 text-gray-700">
                            Telefono
                        </label>
                        <input
                            type="text"
                            id="origen_telefono"
                            :class="[
                                't-input',
                                errors?.origen_telefono && 't-input-invalid',
                            ]"
                            v-model="remitente.origen_telefono"
                        />
                        <small
                            v-if="errors?.origen_telefono"
                            id="telefono-help"
                            class="p-error"
                        >
                            {{ errors.origen_telefono[0] }}
                        </small>
                    </div>
                </div>

                <div class="w-full h-24">
                    <label for="origen_calle" class="my-1 text-gray-700">
                        Calle<span class="text-red-400">*</span>
                    </label>
                    <input
                        type="text"
                        id="origen_calle"
                        :class="['t-input', errors?.calle && 't-input-invalid']"
                        v-model="remitente.origen_calle"
                    />
                    <small
                        v-if="errors?.origen_calle"
                        id="origen_calle-help"
                        class="p-error"
                    >
                        {{ errors.origen_calle[0] }}
                    </small>
                </div>

                <div
                    class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2"
                >
                    <div class="w-full h-24">
                        <label for="origen_altura" class="my-1 text-gray-700">
                            Altura<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="number"
                            id="origen_altura"
                            :class="[
                                't-input',
                                errors?.origen_altura && 't-input-invalid',
                            ]"
                            v-model="remitente.origen_altura"
                        />
                        <small
                            v-if="errors?.origen_altura"
                            id="origen_altura-help"
                            class="p-error"
                        >
                            {{ errors.origen_altura[0] }}
                        </small>
                    </div>

                    <div class="w-full h-24">
                        <label for="origen_piso" class="my-1 text-gray-700">
                            Piso
                        </label>
                        <input
                            type="text"
                            id="origen_piso"
                            :class="[
                                't-input',
                                errors?.origen_piso && 't-input-invalid',
                            ]"
                            v-model="remitente.origen_piso"
                        />
                        <small
                            v-if="errors?.origen_piso"
                            id="origen_piso-help"
                            class="p-error"
                        >
                            {{ errors.origen_piso[0] }}
                        </small>
                    </div>
                </div>

                <div
                    class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2"
                >
                    <div class="w-full h-24">
                        <label for="origen_dpto" class="my-1 text-gray-700">
                            Dpto.
                        </label>
                        <input
                            type="text"
                            id="origen_dpto"
                            :class="[
                                't-input',
                                errors?.origen_dpto && 't-input-invalid',
                            ]"
                            v-model="remitente.origen_dpto"
                        />
                        <small
                            v-if="errors?.origen_dpto"
                            id="origen_dpto-help"
                            class="p-error"
                        >
                            {{ errors.origen_dpto[0] }}
                        </small>
                    </div>

                    <div class="w-full h-24">
                        <label for="origen_cp" class="my-1 text-gray-700">
                            Código Postal<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="cp"
                            :class="[
                                't-input',
                                errors?.origen_cp && 't-input-invalid',
                            ]"
                            v-model="remitente.origen_cp"
                        />
                        <small
                            v-if="errors?.origen_cp"
                            id="cp-help"
                            class="p-error"
                        >
                            {{ errors.origen_cp[0] }}
                        </small>
                    </div>
                </div>

                <div
                    class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2"
                >
                    <div class="w-full h-24">
                        <label
                            for="origen_localidad"
                            class="my-1 text-gray-700"
                        >
                            Localidad<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="origen_localidad"
                            :class="[
                                't-input',
                                errors?.localidad && 't-input-invalid',
                            ]"
                            v-model="remitente.origen_localidad"
                        />
                        <small
                            v-if="errors?.origen_localidad"
                            id="origen_localidad-help"
                            class="p-error"
                        >
                            {{ errors.origen_localidad[0] }}
                        </small>
                    </div>

                    <div class="w-full h-24">
                        <label
                            for="origen_provincia"
                            class="my-1 text-gray-700"
                        >
                            Provincia<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="origen_provincia"
                            :class="[
                                't-input',
                                errors?.origen_provincia && 't-input-invalid',
                            ]"
                            v-model="remitente.origen_provincia"
                        />
                        <small
                            v-if="errors?.origen_provincia"
                            id="origen_provincia-help"
                            class="p-error"
                        >
                            {{ errors.origen_provincia[0] }}
                        </small>
                    </div>
                </div>

                <div class="w-full h-24">
                    <label for="origen_observacion" class="my-1 text-gray-700">
                        Observación
                    </label>
                    <input
                        type="text"
                        id="origen_observacion"
                        :class="[
                            't-input',
                            errors?.origen_observacion && 't-input-invalid',
                        ]"
                        v-model="remitente.origen_observacion"
                    />
                    <small
                        v-if="errors?.origen_observacion"
                        id="observacion-help"
                        class="p-error"
                    >
                        {{ errors.origen_observacion[0] }}
                    </small>
                </div>
            </div>
        </div>
    </XyzTransition>
</template>

<script>
export default {
    name: "RemitenteForm",
    props: {
        sucursales: Array,
        errors: Object,
    },
    data() {
        return {
            remitentePersonalizado: false,
            sucursal_id: null,
            orden_id: null,
            remitente: {
                origen_nombre: "",
                origen_documento: "",
                origen_calle: "",
                origen_altura: "",
                origen_piso: "",
                origen_dpto: "",
                origen_telefono: "",
                origen_observacion: "",
                origen_cp: "",
                origen_email: "",
                origen_localidad: "",
                origen_provincia: "",
            },
        };
    },
    emit: ["clearErrors", "updateRemitente"],
    watch: {
        sucursal_id(newValue) {
            if (newValue !== "") {
                this.setWithSucursal();
                this.$emit("clearErrors");
            }
        },
        orden_id() {
            if (this.sucursal_id !== null) {
                this.setWithSucursal();
            }
        },
        remitentePersonalizado() {
            this.setWithSucursal();
        },
        remitente: {
            deep: true,
            handle() {
                if (this.remitentePersonalizado) {
                    this.$emit("updateRemitente", this.remitente);
                }
            },
        },
    },
    methods: {
        setWithSucursal() {
            let sucursal = this.sucursales.find(
                (s) => s.id === this.sucursal_id
            );
            this.remitente = {
                sucursal_id: this.sucursal_id,
                orden_id: this.orden_id,
                origen_nombre: sucursal.nombre,
                origen_documento: sucursal.documento,
                origen_calle: sucursal.calle,
                origen_altura: sucursal.altura,
                origen_piso: sucursal.piso,
                origen_dpto: sucursal.dpto,
                origen_telefono: sucursal.telefono,
                origen_observacion: sucursal.observacion,
                origen_cp: sucursal.cp,
                origen_email: sucursal.email,
                origen_localidad: sucursal.localidad,
                origen_provincia: sucursal.provincia,
            };
            this.$emit("updateRemitente", this.remitente);
        },
    },
};
</script>

<style scoped>
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type=number] {
    -moz-appearance: textfield;
}
</style>